<template>
  <b-form-group :label="label" :label-sr-only="noLabel">
    <template #label>
      <slot name="label"></slot>
    </template>
    <b-input-group>
      <div class="text-info loader" v-if="loading">
        <b-spinner class="align-middle spinner"></b-spinner>
      </div>
      <slot name="prepend"></slot>
      <b-form-select
        v-model="content"
        :state="state"
        @change="handleInput"
        :options="options"
        :value-field="valueField"
        :text-field="textField"
        :size="size"
        :disabled="disabled"
      />
      <slot name="append"></slot>
      <b-form-invalid-feedback :state="state">{{
        feedback
      }}</b-form-invalid-feedback>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  name: "InputSelect",

  props: {
    value: { type: [String, Number, Object, Array], default: null },
    label: { type: String },
    required: { type: Boolean },
    loading: { type: Boolean },
    requiredMessage: { type: String },
    options: { type: Array, required: true },
    valueField: { type: String, default: "value" },
    textField: { type: String, default: "text" },
    size: { type: String, default: "" },
    noLabel: { type: Boolean, default: false },
    hasErrorCustom: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      content: this.value,
      validForm: false,
      validState: false,
      hasError: false,
      formVerified: false,
      errorMessage: "",
    };
  },
  computed: {
    requiredValid() {
      return !(this.required && !this.value);
    },
    state() {
      if (!this.required && !this.value) return this.hasError ? false : null;
      if (!this.validState && !this.value && !this.formVerified) return null;
      if (this.formVerified && !this.value) return false
      if (!this.validForm && !this.value) return false;
      if (!this.requiredValid) return false;
      if (this.hasError) return false;

      return true;
    },
    feedback() {
      if (!this.requiredValid)
        return (
          this.requiredMessage ||
          this.$t("CAMPOS_VALIDACAO.REQUERIDO").formatUnicorn({
            name: this.label,
          })
        );

      if (this.hasError) return this.errorMessage;
      return "";
    }
  },
  methods: {
    showError(message) {
      this.validForm = true;
      this.formVerified = true;
      this.hasError = true;
      this.errorMessage = message;
    },
    handleInput() {
      this.$emit("input", this.content);
      this.hasError = false;
    },
    valid() {
      this.validForm = true;
      this.formVerified = true;
      this.validState = this.state === null || this.state === true;
      return this.state;
    },
    clear() {
      this.content = "";
      this.validForm = false;
      this.$emit("input", this.content);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.content = value;
      },
      deep: true,
      immediate: true,
    },
    hasErrorCustom(value) {
      this.hasError = value ? true : false;
      this.errorMessage = value;
      this.valid();
    },
  },
};
</script>

<style>
input[readonly] {
  background-color: #f2f3f8 !important;
}
.loader {
  position: absolute;
  padding: 9px;
  z-index: 1;
}

.spinner {
  width: 18px;
  height: 18px;
}
</style>
